import React, { Component } from "react";
import Layout from "../layout/Main";

export default class VerifyPDF extends Component {
  render() {
    return (
      <Layout>
        <div
          class="verifikasipdf"
          style={{
            borderTop: "1px solid rgba(0,0,0,0.12)",
            borderBottom: "1px solid rgba(0,0,0,0.12)",
            height: "90vh",
          }}
        >
          <iframe
            src="https://verifikasipdf.rootca.id"
            // src="https://verifikasipdf.rootca.or.id"
            height="100%"
            width="100%"
          ></iframe>
        </div>
      </Layout>
    );
  }
}
